import { format, isValid } from "date-fns";

export const preventInvalidKey = (e: any) => {
  const invalidKeys = ['e', 'E', '+', '-', '.'];
  if (invalidKeys.includes(e.key)) {
    e.preventDefault();
  }
};


export const dateFormat = 'dd-MM-yyyy';
export const timeFormat = 'hh:mm a';
export const dateTimeFormat = 'dd-MM-yyyy hh:mm a';

const parseSafeDate = (input: string | Date): Date | null => {
  if (!input) return null;

  if (input instanceof Date) {
    return isValid(input) ? input : null;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
    const [year, month, day] = input.split("-");
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const parsed = new Date(input);
  return isValid(parsed) ? parsed : null;
};


const formatSafe = (value: string | Date | undefined | null, pattern: string) => {
  if (!value) return '--';

  const parsed = parseSafeDate(value);
  if (!parsed) return '--';

  return format(parsed, pattern);
};


export const showDate = (date: string | Date | undefined | null) =>
  formatSafe(date, dateFormat);

export const showTime = (time: string | Date | undefined | null) =>
  formatSafe(time, timeFormat);

export const showDateTime = (dateTime: string | Date | undefined | null) =>
  formatSafe(dateTime, dateTimeFormat);